// extracted by mini-css-extract-plugin
export default {"root":"index__root--BilXr","image":"index__image--GQN-v"};